/* eslint-disable arrow-body-style */
import { Box, Modal } from '@mui/material';
import UserNewEditForm from '../../@dashboard/user/UserNewEditForm';
import { User } from 'src/@types/user';

export const UserModal = ({
  open,
  handleClose,
  isEdit,
  currentUser,
}: {
  open: boolean;
  // `saved` is true when closing after a successful create/edit.
  handleClose(saved?: boolean): void;
  isEdit: boolean;
  currentUser: User | undefined;
}) => {
  return (
    <Modal open={open} onClose={() => handleClose()} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Box
        sx={{
          width: '100%',
          maxWidth: 720,
          maxHeight: '92vh',
          overflowY: 'auto',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: { xs: 2.5, sm: 4 },
          outline: 'none',
        }}
      >
        <UserNewEditForm handleClose={handleClose} isEdit={isEdit} currentUser={currentUser} />
      </Box>
    </Modal>
  );
};
